import { apiSlice as api } from '../../../../apiSlice';
export const addTagTypes = ['Units'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      unitsGetCollectionAsyncByqueryOptions: build.query<
        UnitsGetCollectionAsyncByqueryOptionsApiResponse,
        UnitsGetCollectionAsyncByqueryOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/Units`,
          params: {
            orderby: queryArg.orderby,
            orderbydesc: queryArg.orderbydesc,
            'Account.AccountId': queryArg['Account.AccountId'],
            'UnitType.UnitTypeId': queryArg['UnitType.UnitTypeId'],
            top: queryArg.top,
            skip: queryArg.skip,
          },
        }),
        providesTags: ['Units'],
      }),
      unitsPostAsyncByunit: build.mutation<
        UnitsPostAsyncByunitApiResponse,
        UnitsPostAsyncByunitApiArg
      >({
        query: (queryArg) => ({
          url: `/Units`,
          method: 'POST',
          body: queryArg.createUnitDto,
        }),
        invalidatesTags: ['Units'],
      }),
      unitsGetAsyncByid: build.query<
        UnitsGetAsyncByidApiResponse,
        UnitsGetAsyncByidApiArg
      >({
        query: (queryArg) => ({ url: `/Units/${queryArg.id}` }),
        providesTags: ['Units'],
      }),
      unitsDeleteAsyncByid: build.mutation<
        UnitsDeleteAsyncByidApiResponse,
        UnitsDeleteAsyncByidApiArg
      >({
        query: (queryArg) => ({
          url: `/Units/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Units'],
      }),
      unitsPatchAsyncByidunit: build.mutation<
        UnitsPatchAsyncByidunitApiResponse,
        UnitsPatchAsyncByidunitApiArg
      >({
        query: (queryArg) => ({
          url: `/Units/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.editUnitDto,
        }),
        invalidatesTags: ['Units'],
      }),
      unitsGetImageAsyncByid: build.query<
        UnitsGetImageAsyncByidApiResponse,
        UnitsGetImageAsyncByidApiArg
      >({
        query: (queryArg) => ({ url: `/Units/${queryArg.id}/Image` }),
        providesTags: ['Units'],
      }),
      unitsPutImageAsyncByidfile: build.mutation<
        UnitsPutImageAsyncByidfileApiResponse,
        UnitsPutImageAsyncByidfileApiArg
      >({
        query: (queryArg) => ({
          url: `/Units/${queryArg.id}/Image`,
          method: 'PUT',
          body: queryArg.body,
        }),
        invalidatesTags: ['Units'],
      }),
      unitsDeleteImageAsyncByid: build.mutation<
        UnitsDeleteImageAsyncByidApiResponse,
        UnitsDeleteImageAsyncByidApiArg
      >({
        query: (queryArg) => ({
          url: `/Units/${queryArg.id}/Image`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Units'],
      }),
      unitsPostTagAsyncByidnewTag: build.mutation<
        UnitsPostTagAsyncByidnewTagApiResponse,
        UnitsPostTagAsyncByidnewTagApiArg
      >({
        query: (queryArg) => ({
          url: `/Units/${queryArg.id}/Tag`,
          method: 'POST',
          body: queryArg.createTagDto,
        }),
        invalidatesTags: ['Units'],
      }),
      unitsDeleteTagAsyncByidtag: build.mutation<
        UnitsDeleteTagAsyncByidtagApiResponse,
        UnitsDeleteTagAsyncByidtagApiArg
      >({
        query: (queryArg) => ({
          url: `/Units/${queryArg.id}/Tag`,
          method: 'DELETE',
          params: {
            tag: queryArg.tag,
          },
        }),
        invalidatesTags: ['Units'],
      }),
      unitsResetAlarmByidalarmTypeId: build.mutation<
        UnitsResetAlarmByidalarmTypeIdApiResponse,
        UnitsResetAlarmByidalarmTypeIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Units/${queryArg.id}/ResetAlarm/${queryArg.alarmTypeId}`,
          method: 'PATCH',
        }),
        invalidatesTags: ['Units'],
      }),
      unitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataType:
        build.mutation<
          UnitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataTypeApiResponse,
          UnitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataTypeApiArg
        >({
          query: (queryArg) => ({
            url: `/Units/${queryArg.unitId}/AlarmConfiguration/${queryArg.key}/${queryArg.unitTypeInputId}/${queryArg.dataType}`,
            method: 'PUT',
            params: {
              value: queryArg.value,
            },
          }),
          invalidatesTags: ['Units'],
        }),
      unitsGetAlarmConfigurationAsyncByid: build.query<
        UnitsGetAlarmConfigurationAsyncByidApiResponse,
        UnitsGetAlarmConfigurationAsyncByidApiArg
      >({
        query: (queryArg) => ({
          url: `/Units/${queryArg.id}/AlarmConfiguration`,
        }),
        providesTags: ['Units'],
      }),
      unitsGetAllAlarmConfigurationsAsync: build.query<
        UnitsGetAllAlarmConfigurationsAsyncApiResponse,
        UnitsGetAllAlarmConfigurationsAsyncApiArg
      >({
        query: () => ({ url: `/Units/AlarmConfiguration` }),
        providesTags: ['Units'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as recalcOpenApi };
export type UnitsGetCollectionAsyncByqueryOptionsApiResponse =
  /** status 200 Unit entities response */ ReadUnitDto[];
export type UnitsGetCollectionAsyncByqueryOptionsApiArg = {
  /** <p><a href='#queryoptions'>Sorts</a> the result in ascending order by the supplied property.</p><p>Valid values are: <strong>UnitId</strong> (default), <strong>Name</strong>.</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderby?: string;
  /** <p><a href='#queryoptions'>Sorts</a> the result in descending order by the supplied property.</p><p>Valid values are: <strong>UnitId</strong> (default), <strong>Name</strong>.</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderbydesc?: string;
  /** <p><a href="#queryoptions">Filters</a> the result by Account.AccountId using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(int)</code></pre></div><p>Examples:</p><div><pre>Equal to:
    <code>eq(3001)</code></pre></div> */
  'Account.AccountId'?: string;
  /** <p><a href="#queryoptions">Filters</a> the result by UnitType.UnitTypeId using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(int)</code></pre></div><p>Examples:</p><div><pre>Equal to:
    <code>eq(3001)</code></pre></div> */
  'UnitType.UnitTypeId'?: string;
  /** <a href="#queryoptions">Query paging</a> Returns the maximum number of entities. Default and max value is 10000 */
  top?: number;
  /** <a href="#queryoptions">Query paging</a> Skips this number of entities */
  skip?: number;
};
export type UnitsPostAsyncByunitApiResponse = /** status 201 Created */ object;
export type UnitsPostAsyncByunitApiArg = {
  /** The entity to create */
  createUnitDto: CreateUnitDto;
};
export type UnitsGetAsyncByidApiResponse =
  /** status 200 Unit entity response */ ReadUnitDto;
export type UnitsGetAsyncByidApiArg = {
  /** Id of entity to retrieve */
  id: number;
};
export type UnitsDeleteAsyncByidApiResponse =
  /** status 204 No content */ object;
export type UnitsDeleteAsyncByidApiArg = {
  /** Id of entity to delete */
  id: number;
};
export type UnitsPatchAsyncByidunitApiResponse =
  /** status 204 No content */ object;
export type UnitsPatchAsyncByidunitApiArg = {
  /** The id the entity to update */
  id: number;
  /** The entity to update */
  editUnitDto: EditUnitDto;
};
export type UnitsGetImageAsyncByidApiResponse = /** status 200 Ok */ Blob;
export type UnitsGetImageAsyncByidApiArg = {
  /** Id of the unit entity */
  id: number;
};
export type UnitsPutImageAsyncByidfileApiResponse =
  /** status 201 Created */ object;
export type UnitsPutImageAsyncByidfileApiArg = {
  /** Id of the unit entity */
  id: number;
  body: {
    /** The image file to upload */
    file: Blob;
  };
};
export type UnitsDeleteImageAsyncByidApiResponse =
  /** status 204 No content */ object;
export type UnitsDeleteImageAsyncByidApiArg = {
  /** Id of the unit entity */
  id: number;
};
export type UnitsPostTagAsyncByidnewTagApiResponse =
  /** status 201 Created */ object;
export type UnitsPostTagAsyncByidnewTagApiArg = {
  /** The id of the Unit */
  id: number;
  /** The tag to create or reference */
  createTagDto: CreateTagDto;
};
export type UnitsDeleteTagAsyncByidtagApiResponse =
  /** status 204 No content */ object;
export type UnitsDeleteTagAsyncByidtagApiArg = {
  /** The id of the entity to delete */
  id: number;
  /** The tag text to delete */
  tag: string;
};
export type UnitsResetAlarmByidalarmTypeIdApiResponse =
  /** status 204 No content */ object;
export type UnitsResetAlarmByidalarmTypeIdApiArg = {
  /** Id of the unit */
  id: number;
  /** Id of the alarm type */
  alarmTypeId: number;
};
export type UnitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataTypeApiResponse =
  /** status 204 No content */ object;
export type UnitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataTypeApiArg =
  {
    /** The id of the Unit */
    unitId: number;
    /** The unitTypeInputIdt */
    unitTypeInputId: number;
    /** Configuration key */
    key: string;
    /** Configuration value */
    value?: string;
    /** Configuration dataType (optional) */
    dataType: string;
  };
export type UnitsGetAlarmConfigurationAsyncByidApiResponse =
  /** status 200 Alarm configurations response */ ReadAlarmTypeConfigurationDto[];
export type UnitsGetAlarmConfigurationAsyncByidApiArg = {
  /** The id of the Unit */
  id: number;
};
export type UnitsGetAllAlarmConfigurationsAsyncApiResponse =
  /** status 200 AlarmConfigurations entities response */ ReadAlarmTypeConfigurationDto[];
export type UnitsGetAllAlarmConfigurationsAsyncApiArg = void;
export type ReadSensorRequirement = {
  SensorRequirementId: number;
  IsRequired: boolean;
  DataType?: string;
};
export type ReadAlarmTypeConfigurationSpecDto = {
  Key?: string;
  Type: 'Integer' | 'Datetime';
  AlarmTypeId: number;
};
export type ReadUnitTypeInputDto = {
  UnitTypeInputId: number;
  Description?: string;
  Name: string;
  SensorRequirements?: ReadSensorRequirement[];
  AlarmTypeConfigurations?: ReadAlarmTypeConfigurationSpecDto[];
};
export type SensorNoRefsDto = {
  SensorId: number;
  DataLastRecorded?: string;
  IsConfigured: boolean;
  SensorType:
    | 'AccessPoint'
    | 'PowerMoniSpot'
    | 'PowerMoniMain'
    | 'FlowMoniSpot'
    | 'HeatMoniSpot'
    | 'TempMoniSpot'
    | 'AnalogMoniSpot'
    | 'FlowMoniVolume'
    | 'TempMoniDC'
    | 'FlowMoniEnergy'
    | 'AnalogMoniActive'
    | 'GatewaySensor';
  ChannelCount: number;
  CalibrationConstant?: number;
  CalibrationType?:
    | 'Level1'
    | 'Level2ApparentPower'
    | 'Level2Current'
    | 'PowerDisaggregation';
  DataInterval?:
    | 'Minute'
    | 'Minutes5'
    | 'Seconds20Boost'
    | 'Seconds3Boost'
    | 'Minutes30'
    | 'Inactive'
    | 'Second'
    | 'Custom';
  TargetDataInterval?:
    | 'Minute'
    | 'Minutes5'
    | 'Seconds20Boost'
    | 'Seconds3Boost'
    | 'Minutes30'
    | 'Inactive'
    | 'Second'
    | 'Custom';
  MotorMonitoringEnabled: boolean;
  VolumeConstant?: number;
  TargetVolumeConstant?: number;
  FlowGap?: number;
  TargetFlowGap?: number;
};
export type ManufacturerNoRefsDto = {
  ManufacturerId: number;
  Name?: string;
  EncryptionKeyRequired: boolean;
};
export type ReadExternalSensorChannelDto = {
  ExternalSensorDeviceId: number;
  DataType?: string;
  ChannelNumber: number;
  ChannelName?: string;
};
export type ReadExternalSensorDeviceDto = {
  Key?: string;
  Name?: string;
  Manufacturer?: ManufacturerNoRefsDto;
  Channels?: ReadExternalSensorChannelDto[];
  ExternalSensorType: 'Remoni' | 'WmBus';
  MeterType?: string;
  ExternalSensorDeviceId: number;
};
export type AccountNoRefsDto = {
  AccountId: number;
  Name: string;
  Address: string;
  BillingAddress?: string;
};
export type GatewayActivitiesNoRefsDto = {
  SensorId: number;
  GatewayId: number;
  SensorType:
    | 'AccessPoint'
    | 'PowerMoniSpot'
    | 'PowerMoniMain'
    | 'FlowMoniSpot'
    | 'HeatMoniSpot'
    | 'TempMoniSpot'
    | 'AnalogMoniSpot'
    | 'FlowMoniVolume'
    | 'TempMoniDC'
    | 'FlowMoniEnergy'
    | 'AnalogMoniActive'
    | 'GatewaySensor';
  LastActivity: string;
  ReceivedSignalStrengthIndication?: number;
  LinkQualityIndication?: number;
};
export type GatewayExternalActivitiesNoRefsDto = {
  ExternalSensorId: number;
  GatewayId: number;
  LastActivity: string;
  ReceivedSignalStrengthIndication?: number;
};
export type GatewayConnectionStatus = {
  LatestDongleTimestamp?: string;
  LatestDongleSignalLevel?: number;
  LatestDongleImei?: string;
  LatestDongleWorkmode?: string;
  LatestDongleDeviceName?: string;
  LatestWifiTimestamp?: string;
  LatestWifiSignalLevel?: number;
  LatestWifiIpAddress?: string;
  LatestWifiMacAddress?: string;
  LatestWifiSsid?: string;
  LatestWifiChannel?: number;
  LatestWifiFrequency?: number;
  LatestMobileTimestamp?: string;
  LatestMobileImsi?: string;
  LatestMobileApn?: string;
  LatestMobileRssi?: number;
  LatestMobileRsrq?: number;
  LatestMobileRsrp?: number;
  LatestMobileCinr?: number;
  LatestEthernetTimestamp?: string;
  LatestEthernetIpAddress?: string;
  LatestEthernetMac?: string;
};
export type ReadGatewayDto = {
  GatewayId: number;
  Name?: string;
  Description?: string;
  ImageHash?: number;
  Account?: AccountNoRefsDto;
  LastActivity?: string;
  RegistrationDate?: string;
  SensorActivities?: GatewayActivitiesNoRefsDto[];
  ExternalSensorActivities?: GatewayExternalActivitiesNoRefsDto[];
  Latitude?: number;
  Longitude?: number;
  LocationAccuracy?: number;
  CurrentApplicationFirmware?: string;
  CurrentCommonFirmware?: string;
  ReportedApplicationFirmware?: string;
  Variant: 'Repeater' | 'Gateway';
  Online?: boolean;
  ConnectionStatus?: GatewayConnectionStatus;
  ApMode?: 'Normal' | 'WmBus';
  TargetApMode?: 'Normal' | 'WmBus';
  GatewayVersion?: string;
  HWRevision?: string;
  SWRevision?: string;
  OptoEye: boolean;
  Modem: boolean;
  PCT: boolean;
};
export type UnitNoRefsDto = {
  UnitId: number;
  Name: string;
  Description?: string;
  Latitude?: number;
  Longitude?: number;
  GpsAccuracy?: number;
};
export type ReadExternalSensorUnitSensorDto = {
  UnitSensorId: number;
  ChannelNumber: number;
  UnitTypeInputId: number;
  Unit: UnitNoRefsDto;
};
export type ExternalSensorActivitiesNoRefsDto = {
  ExternalSensorId: number;
  GatewayId: number;
  LastActivity: string;
  ReceivedSignalStrengthIndication?: number;
};
export type ReadWmBusDeviceDto = {
  State?: 'Unconfirmed' | 'Ok';
  EncryptionKey?: string;
  RegisteredToGateway?: boolean;
  LastConfigChange?: string;
};
export type ReadExternalSensorDto = {
  Device?: ReadExternalSensorDeviceDto;
  Gateway?: ReadGatewayDto;
  ExternalSensorId: number;
  Name?: string;
  AccountId?: number;
  UnitSensors?: ReadExternalSensorUnitSensorDto[];
  DeviceId?: string;
  GatewayId?: number;
  ExternalSensorActivities?: ExternalSensorActivitiesNoRefsDto[];
  WmBusDevice?: ReadWmBusDeviceDto;
};
export type ReadUnitSensorDto = {
  UnitSensorId: number;
  ChannelNumber: number;
  UnitTypeInput?: ReadUnitTypeInputDto;
  Sensor?: SensorNoRefsDto;
  ExternalSensor?: ReadExternalSensorDto;
  CustomName?: string;
  ApiInput: boolean;
};
export type UnitTypeNoRefsDto = {
  UnitTypeId: number;
  Name: string;
  Description?: string;
};
export type TagNoRefsDto = {
  TagId: number;
  Text: string;
};
export type UnitTypeInputNameDto = {
  UnitTypeInputId: number;
  Name?: string;
};
export type RecordedDataTypesDto = {
  UnitTypeInput?: UnitTypeInputNameDto;
  DataTypes?: string[];
};
export type ReadUnitDto = {
  UnitId: number;
  Name: string;
  Description?: string;
  Latitude?: number;
  Longitude?: number;
  GpsAccuracy?: number;
  ImageHash?: number;
  UnitSensors?: ReadUnitSensorDto[];
  Account: AccountNoRefsDto;
  UnitType: UnitTypeNoRefsDto;
  Tags?: TagNoRefsDto[];
  RecordedDataTypes?: RecordedDataTypesDto[];
};
export type ErrorResult = {
  Code: string;
  Message: string;
};
export type BadRequestError = {
  Code: string;
  Message: string;
};
export type PropertyValueError = {
  Property: string;
  Code: string;
  Message: string;
};
export type ArrayProperty = {
  Property?: ArrayProperty;
  Name: string;
  Index?: number;
};
export type ArrayPropertyValueError = {
  Property: ArrayProperty;
  Code: string;
  Message: string;
};
export type ErrorDetailsResult2 = ErrorResult & {
  BadRequestErrors?: BadRequestError[];
  PropertyValueErrors?: PropertyValueError[];
  ArrayPropertyValueErrors?: ArrayPropertyValueError[];
};
export type ErrorDetailsResult = ErrorDetailsResult2;
export type ErrorResult2 = ErrorResult;
export type ErrorResult3 = ErrorResult;
export type ErrorResult4 = ErrorResult;
export type UnitTypeInputIdDto = {
  UnitTypeInputId: number;
};
export type SensorIdDto = {
  SensorId: number;
};
export type ExternalSensorIdDto = {
  ExternalSensorId: number;
};
export type WriteUnitSensorDto = {
  UnitTypeInput?: UnitTypeInputIdDto;
  Sensor?: SensorIdDto;
  ExternalSensor?: ExternalSensorIdDto;
  ApiInput: boolean;
  ChannelNumber: number;
  CustomName?: string;
};
export type AccountIdDto = {
  AccountId: number;
};
export type UnitTypeIdDto = {
  UnitTypeId: number;
};
export type CreateUnitDto = {
  Name?: string;
  Description?: string;
  Latitude?: number;
  Longitude?: number;
  GpsAccuracy?: number;
  UnitSensors?: WriteUnitSensorDto[];
  Account?: AccountIdDto;
  UnitType?: UnitTypeIdDto;
};
export type EditUnitDto = {
  Name?: string;
  Description?: string;
  Latitude?: number;
  Longitude?: number;
  GpsAccuracy?: number;
  UnitSensors?: WriteUnitSensorDto[];
};
export type CreateTagDto = {
  Text: string;
};
export type ReadAlarmTypeConfigurationDto = {
  UnitId?: number;
  UnitTypeInputId?: number;
  Key?: string;
  Type: 'Integer' | 'Datetime';
  AlarmTypeId: number;
  Value?: string;
  DataType?: string;
};
export const {
  useUnitsGetCollectionAsyncByqueryOptionsQuery,
  useLazyUnitsGetCollectionAsyncByqueryOptionsQuery,
  useUnitsPostAsyncByunitMutation,
  useUnitsGetAsyncByidQuery,
  useLazyUnitsGetAsyncByidQuery,
  useUnitsDeleteAsyncByidMutation,
  useUnitsPatchAsyncByidunitMutation,
  useUnitsGetImageAsyncByidQuery,
  useLazyUnitsGetImageAsyncByidQuery,
  useUnitsPutImageAsyncByidfileMutation,
  useUnitsDeleteImageAsyncByidMutation,
  useUnitsPostTagAsyncByidnewTagMutation,
  useUnitsDeleteTagAsyncByidtagMutation,
  useUnitsResetAlarmByidalarmTypeIdMutation,
  useUnitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataTypeMutation,
  useUnitsGetAlarmConfigurationAsyncByidQuery,
  useLazyUnitsGetAlarmConfigurationAsyncByidQuery,
  useUnitsGetAllAlarmConfigurationsAsyncQuery,
  useLazyUnitsGetAllAlarmConfigurationsAsyncQuery,
} = injectedRtkApi;
